import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ChevronRight } from 'lucide-react';

interface PartnerCardProps {
  logo: string;
  name: string;
  description: string;
  category: string;
  url: string;
  index?: number;
}

export function PartnerCard({ logo, name, description, category, url, index = 0 }: PartnerCardProps) {
  useLanguage();
  return (
    <div 
      className="w-full h-[212px] bg-white border border-[#E7EAF3] rounded-[14px] p-[22px]
                 shadow-[0_6px_22px_rgba(0,0,0,0.06)] transition-all duration-[180ms] ease-in-out
                 flex flex-col group
                 hover:scale-[1.02] hover:shadow-[0_8px_26px_rgba(0,0,0,0.12)] 
                 hover:border-[#C8D1E0] hover:bg-white/85 hover:backdrop-blur-[4px]
                 animate-[fadeInUp_0.35s_ease-out_forwards]"
      style={{ animationDelay: `${index * 80}ms`, opacity: 0 }}
    >
      {/* Logo Container */}
      <div className="w-20 h-14 flex items-center justify-start flex-shrink-0">
        <img
          src={logo}
          alt={translateInterfaceText("Logo {value0}", { value0: (name) })}
          className="max-w-full max-h-full object-contain"
        />
      </div>
      
      {/* Partner Name */}
      <h2 className="text-[15px] font-semibold text-[#1A1F36] mt-3 flex-shrink-0">
        {name}
      </h2>
      
      {/* Description */}
      <p className="text-[14px] text-[#637083] leading-[1.45] mt-1.5 line-clamp-3 flex-grow">
        {description}
      </p>
      
      {/* Footer: Category + CTA */}
      <div className="flex items-center justify-between mt-auto pt-2.5 flex-shrink-0">
        <span className="text-[12px] text-[#A0AEC0]">
          {translateInterfaceText(category)}
        </span>
        
        <a 
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={translateInterfaceText("Visitar parceiro {value0}", { value0: (name) })}
          className="flex items-center gap-0.5 text-[#3B7BFF] text-[14px] font-medium
                     hover:underline"
        >
          {translateInterfaceText("Visitar")}<ChevronRight
            size={16} 
            className="transition-transform duration-150 group-hover:translate-x-0.5" 
          />
        </a>
      </div>
    </div>
  );
}
